<template>
  <loading v-if="isLoading" />
  <div v-else class="content-section">
    <progress-bar :currentStep="3"></progress-bar>
    <img
      src="../assets/images/capitecpay.png"
      alt="Capitec pay"
      class="capitecpay-logo"
    />

    <span class="countdown"
      >You have <template v-if="hours > 0">{{ hours }} hour </template>
      <template v-if="minutes > 0">{{ minutes }} min</template>
      {{ seconds > 0 ? seconds : 0 }} sec to...</span
    >

    <div class="modal-steps">
      <div class="modal-steps__1">
        <img
          src="../assets/images/step-1.png"
          alt="Mobile"
          height="32"
          width="20"
        />
        <h3>Step 1</h3>
      </div>
      <p>Sign in on your Capitec app</p>
      <div class="modal-steps__2">
        <img
          src="../assets/images/step-2.png"
          alt="Mobile"
          height="26"
          width="32"
        />
        <h3>Step 2</h3>
      </div>
      <p>Tap Transact</p>
      <div class="modal-steps__3">
        <img
          src="../assets/images/step-3.png"
          alt="Mobile"
          height="21"
          width="28"
        />
        <h3>Step 3</h3>
      </div>
      <p>Tap Capitec Pay and approve the payment</p>
    </div>
  </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar.vue'
import { mapState, mapActions } from 'vuex'
import Loading from '@/components/Loading'
export default {
  name: 'BankAuthTimer',
  components: { ProgressBar, Loading },
  data() {
    return {
      minutes: 0,
      seconds: 0,
      hours: 0,
      counter: 120,
      isLoading: true,
    }
  },
  computed: {
    ...mapState('transaction', ['timeToLive']),
  },
  methods: {
    ...mapActions('transaction', ['setShowCancel']),
    timer() {
      setInterval(() => {
        this.seconds = --this.counter % 60
        this.minutes = parseInt(this.counter / 60) % 60
        this.hours = parseInt(this.counter / 3600) % 24
        if (this.isLoading) this.isLoading = false
      }, 1000)
    },
  },
  created() {
    this.setShowCancel(false)
    this.counter = this.timeToLive ?? 120
    this.timer()
  },
}
</script>

<style lang="scss" scoped>
$forestGreen: #022d2d;
$forestGreen300: #439292;
$grey: #545a5a;

.content-section {
  h3 {
    font-weight: 700;
    font-size: 1.2em;
    text-align: center;
  }

  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }
}

.capitecpay-logo {
  display: block;
  margin: 0 auto;
  padding-top: 32px;
}

.inputs-switch {
  font-weight: 400;
  font-size: 1em;
  text-align: center;
  span {
    text-decoration: underline;
    cursor: pointer;
  }
}

.pay-button {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}

.countdown {
  display: flex;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
  color: $grey;
  margin-top: 36px;
}

.modal-steps {
  display: flex;
  flex-direction: column;
  align-items: center;
  &__1,
  &__2,
  &__3 {
    display: flex;
    align-items: center;
    padding-top: 16px;
    img {
      margin-right: 8px;
    }
    h3 {
      font-weight: 700;
      font-size: 18px;
      color: $forestGreen;
    }
  }
  a {
    font-weight: 400;
    font-size: 16px;
    color: $forestGreen300;
    text-decoration: none;
  }
  span {
    font-weight: 600;
    font-size: 16px;
    color: $forestGreen;
    padding: 48px 0;
  }
}

.input-block {
  align-items: center;
}
</style>
